import React from 'react';
import { Smartphone, ArrowRight, Play } from 'lucide-react';

const Hero = ({ language }) => {
  const texts = {
    en: {
      title: 'Discover Amazing Mobile Games & Apps',
      subtitle: 'Explore top-rated mobile games and essential apps. Start instantly and begin playing today.',
      cta: 'Browse Games',
      subtitle2: 'Your one-stop destination for mobile entertainment'
    },
    sl: {
      title: 'Odkrijte neverjetne mobilne igre in aplikacije',
      subtitle: 'Raziščite najboljšje mobilne igre in nujne aplikacije. Začnite takoj in začnite igrati še danes.',
      cta: 'Prebrskaj igre',
      subtitle2: 'Vaša destinacija za mobilno zabavo'
    }
  };

  const t = texts[language];

  return (
    <section id="section-1" className="relative py-20 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-blue-50 to-indigo-100">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left side - Content */}
          <div className="space-y-8">
            <div className="space-y-4">
              <h1 className="text-5xl lg:text-6xl font-bold text-gray-900 leading-tight">
                {t.title}
              </h1>
              <p className="text-xl text-gray-600 leading-relaxed">
                {t.subtitle}
              </p>
              <p className="text-lg text-gray-500">
                {t.subtitle2}
              </p>
            </div>

            {/* CTA Button */}
            <div className="flex flex-col sm:flex-row gap-4">
              <a href="/s" className="inline-flex items-center justify-center px-8 py-4 bg-blue-600 text-white rounded-xl font-semibold text-lg hover:bg-blue-700 transition-colors duration-200 shadow-lg">
                <Play className="w-5 h-5 mr-2" />
                <span>{t.cta}</span>
                <ArrowRight className="w-5 h-5 ml-2" />
              </a>
            </div>

            <div className="flex items-center space-x-2 text-blue-600">
              <Smartphone className="w-5 h-5" />
              <span className="text-sm font-medium">
                {language === 'en' ? 'Available on all mobile devices' : 'Na voljo za vse mobilne naprave'}
              </span>
            </div>
          </div>

          {/* Right side - Hero Image */}
          <div className="relative">
            {/* Decorative background elements */}
            <div className="absolute -z-10 top-8 right-8 w-72 h-72 bg-blue-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob"></div>
            <div className="absolute -z-10 bottom-8 left-8 w-72 h-72 bg-indigo-400 rounded-full mix-blend-multiply filter blur-xl opacity-20 animate-blob animation-delay-2000"></div>
            
            <div className="relative rounded-2xl shadow-2xl overflow-hidden group">
              <div className="absolute inset-0 bg-gradient-to-tr from-blue-600/10 to-indigo-600/10 rounded-2xl z-10"></div>
              <img
                src="/images/hero-mobile-games.jpeg"
                alt={language === 'en' ? 'Mobile games and apps on smartphone' : 'Mobilne igre in aplikacije na pametnem telefonu'}
                className="w-full h-auto rounded-2xl transform group-hover:scale-105 transition-transform duration-500"
              />
              
              {/* Floating badge */}
              <div className="absolute top-4 right-4 bg-white/95 backdrop-blur-sm rounded-xl px-4 py-2 shadow-lg z-20 animate-pulse">
                <div className="flex items-center space-x-2">
                  <div className="w-2 h-2 bg-green-500 rounded-full animate-ping"></div>
                  <span className="text-sm font-semibold text-gray-800">
                    {language === 'en' ? '1000+ Games' : '1000+ Iger'}
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;
